<template>
  <div class="flex flex-col md:flex-row bg-white rounded-lg overflow-hidden min-h-[300px]">
    <aside ref="asideRef" class="w-full md:w-64 bg-base-200 border border-base-300 p-4 md:p-6 rounded-t-lg md:rounded-l-lg md:rounded-tr-none">
      <ul class="menu space-y-2" role="tablist" aria-orientation="vertical">
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'extra' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-extra"
            @click="selectedTab = 'extra'"
          >
            <Icon icon="heroicons-outline:wrench" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.title') }}</span>
          </button>
        </li>
        
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'guidance' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-guidance"
            @click="selectedTab = 'guidance'"
          >
            <Icon icon="heroicons-outline:light-bulb" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.dontKnowMessageTitle') }}</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'startingButtons' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-starting-buttons"
            @click="selectedTab = 'startingButtons'"
          >
            <Icon icon="heroicons-outline:play" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.startingButtonsTitle', 'Starting Buttons') }}</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'responseFilters' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-response-filters"
            @click="selectedTab = 'responseFilters'"
          >
            <Icon icon="heroicons-outline:adjustments-horizontal" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.responseFiltersTitle', 'Response Filters') }}</span>
          </button>
        </li>
        <li v-if="showVectorDbTab === true">
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'vectorDb' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-vector-db"
            @click="selectedTab = 'vectorDb'"
          >
            <Icon icon="heroicons-outline:circle-stack" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.vectorDbTitle', 'Vector Database') }}</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'bugFixing' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            :aria-selected="selectedTab === 'bugFixing'"
            aria-controls="advanced-bug-fixing"
            @click="openBugFixingTab"
          >
            <Icon icon="heroicons-outline:bug-ant" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.bugFixingTitle', 'Bug fixing') }}</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'omni' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-omni"
            @click="selectedTab = 'omni'"
          >
            <Icon icon="heroicons-outline:chat-bubble-left-right" class="w-5 h-5 md:w-6 md:h-6" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.omniTitle', 'Omni Settings') }}</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            :class="[
              'w-full flex items-center justify-between px-4 py-3 text-base md:text-lg font-medium rounded transition-colors',
              'text-right',
              selectedTab === 'promptVersions' ? 'bg-white text-primary shadow ring-1 ring-primary/20' : 'text-gray-700 hover:text-gray-900 hover:bg-base-100'
            ]"
            role="tab"
            aria-selected="false"
            aria-controls="advanced-prompt-versions"
            @click="selectedTab = 'promptVersions'"
          >
            <Icon icon="heroicons-outline:rectangle-stack" class="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" />
            <span class="flex-1 text-left">{{ t('aiChatAgentSetup.advanced.promptVersionsTitle', 'Prompt Versions') }}</span>
          </button>
        </li>
      </ul>
    </aside>
    <div class="flex-1 p-4 md:p-6 bg-white">
      
      <section
        id="advanced-guidance"
        v-show="selectedTab === 'guidance'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.dontKnowMessageTitle') }}</h2>
        <p class="text-sm text-gray-500 mb-4">{{ t('aiChatAgentSetup.advanced.dontKnowMessageDescription') }}</p>
        <div class="form-control w-full max-w-2xl">
          <div class="flex items-center justify-end mb-2">
            <label class="sr-only">Language</label>
            <select v-model="selectedGuidanceLang" class="select select-bordered select-sm" aria-label="Language">
              <option v-for="lang in props.languages" :key="lang.code" :value="lang.code">{{ lang.name }}</option>
            </select>
          </div>
          <label class="label">
            <span class="label-text">{{ t('aiChatAgentSetup.advanced.messageLabel', 'Message') }}</span>
          </label>
          <textarea
            v-model="currentGuidanceMessage"
            class="textarea textarea-bordered w-full"
            style="min-height:120px;"
            :placeholder="t('aiChatAgentSetup.advanced.dontKnowMessagePlaceholder', 'Enter the message used when the agent does not know the answer')"
            aria-label="Guidance message"
          ></textarea>
          <div class="mt-1 text-xs text-gray-400 text-right">{{ guidanceChars }} {{ t('reports.charsSuffix', 'chars') }}</div>
        </div>

        <div class="divider my-8"></div>

        <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.networkErrorMessageTitle', 'Network Error Message') }}</h2>
        <p class="text-sm text-gray-500 mb-4">{{ t('aiChatAgentSetup.advanced.networkErrorMessageDescription', 'Define a custom message to show when a network error occurs during chat.') }}</p>
        <div class="form-control w-full max-w-2xl">
          <div class="flex items-center justify-end mb-2">
            <label class="sr-only">Language</label>
            <select v-model="selectedNetworkErrorLang" class="select select-bordered select-sm" aria-label="Language">
              <option v-for="lang in props.languages" :key="lang.code" :value="lang.code">{{ lang.name }}</option>
            </select>
          </div>
          <label class="label">
            <span class="label-text">{{ t('aiChatAgentSetup.advanced.messageLabel', 'Message') }}</span>
          </label>
          <textarea
            v-model="currentNetworkErrorMessage"
            class="textarea textarea-bordered w-full"
            style="min-height:120px;"
            :placeholder="t('aiChatAgentSetup.advanced.networkErrorMessagePlaceholder', 'Enter the message used when a network error occurs')"
            aria-label="Network error message"
          ></textarea>
          <div class="mt-1 text-xs text-gray-400 text-right">{{ networkErrorChars }} {{ t('reports.charsSuffix', 'chars') }}</div>
        </div>
      </section>
      <section
        id="advanced-extra"
        v-show="selectedTab === 'extra'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <div class="grid max-w-xl grid-space-4">
          
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.retrieveUserLocationLabel') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.retrieveUserLocationTooltip.title') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.retrieveUserLocationTooltip.description') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="retrieveUserLocationLocal"
                @change.stop="onRetrieveUserLocationChange"
                class="toggle toggle-primary"
                aria-label="Retrieve user location"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.showMapLabel', 'Show map for addresses') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.showMapTooltip.title', 'Display address map') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.showMapTooltip.description', 'Allow the assistant to return a locationAddress tag so the public chat can render a map preview with navigation links.') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="showMapLocal"
                @change.stop="onShowMapChange"
                class="toggle toggle-primary"
                aria-label="Show map for addresses"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.enableFileUploadInChatLabel') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.enableFileUploadInChatTooltip.title') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.enableFileUploadInChatTooltip.description') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="enableFileUploadInChatLocal"
                @change.stop="onEnableFileUploadInChatChange"
                class="toggle toggle-primary"
                aria-label="Enable file upload in chat"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.makeLinksClickableLabel', 'Make URLs and Phone Numbers Clickable') }}</span>
              </div>
              <input
                type="checkbox"
                :checked="makeLinksClickableLocal"
                @change.stop="onMakeLinksClickableChange"
                class="toggle toggle-primary"
                aria-label="Make URLs and Phone Numbers Clickable"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.enableUserFineTuneLabel', 'Enable user fine-tune') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.enableUserFineTuneTooltip.title', 'Allow users to submit better answers') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.enableUserFineTuneTooltip.description', 'When users dislike a reply, let them add a fine-tune entry for this agent.') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="enableUserFineTuneLocal"
                @change.stop="onEnableUserFineTuneChange"
                class="toggle toggle-primary"
                aria-label="Enable user fine-tune"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.clearSessionOnRefreshLabel') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.clearSessionOnRefreshTooltip.title') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.clearSessionOnRefreshTooltip.description') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="clearSessionOnRefreshLocal"
                @change.stop="onClearSessionOnRefreshChange"
                class="toggle toggle-primary"
                aria-label="Clear session on page refresh"
              />
            </div>
          </div>
          <div v-if="props.isVoiceOnly !== true || props.showAllFields === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.enabledSavedSessionHistoryLabel', 'Enable saved session history') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.enabledSavedSessionHistoryTooltip.title', 'Allow session resume') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.enabledSavedSessionHistoryTooltip.description', 'Allow public chat sessions to load previous messages for the same session.') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="enabledSavedSessionHistoryLocal"
                @change.stop="onEnabledSavedSessionHistoryChange"
                class="toggle toggle-primary"
                aria-label="Enable saved session history"
              />
            </div>
          </div>
          <div v-if="props.showRegularOpenAiContentFilterFailover === true" class="form-control w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.regularOpenAiContentFilterFailoverLabel', 'Use regular OpenAI if Azure blocks a request') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.regularOpenAiContentFilterFailoverTooltip.title', 'Regular OpenAI content-filter failover') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.regularOpenAiContentFilterFailoverTooltip.description', 'When Azure OpenAI rejects a request because of its content filter, retry it once with the matching regular OpenAI model. This does not apply to other errors.') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="regularOpenAiContentFilterFailoverEnabledLocal"
                @change.stop="onRegularOpenAiContentFilterFailoverEnabledChange"
                class="toggle toggle-warning"
                aria-label="Use regular OpenAI if Azure blocks a request"
              />
            </div>
          </div>
          <div class="form-control w-full">
            <div class="form-control w-full mt-6">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <span>{{ t('aiChatAgentSetup.advanced.documentAmountLabel', 'Document amount') }}</span>
                </div>
                <input
                  type="number"
                  min="1"
                  :max="retrieverKValueInputMax"
                  :value="retrieverKValueLocal"
                  @input="onRetrieverKValueInput($event.target.value)"
                  class="input input-bordered w-28 text-right"
                  :placeholder="t('aiChatAgentSetup.advanced.sourcesKPlaceholder', 'e.g. 30')"
                  aria-label="Document amount"
                />
              </div>
            </div>
          <div class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.maxOutputTokensLabel', 'Max answer tokens') }}</span>
              </div>
              <input
                type="number"
                min="1"
                :max="maxOutputTokensInputMax"
                :value="maxOutputTokensLocal"
                @input="onMaxOutputTokensInput($event.target.value)"
                class="input input-bordered w-28 text-right"
                :placeholder="t('aiChatAgentSetup.advanced.maxOutputTokensPlaceholder', 'e.g. 2048')"
                aria-label="Max answer tokens"
              />
            </div>
          </div>
          <div v-if="verificationModelOptions.length > 0" class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.verificationAgentLlmLabel', 'Verification agent LLM') }}</span>
              </div>
              <select
                class="select select-bordered w-64 text-right"
                :value="selectedVerificationLLMModelLocal"
                @change="onSelectedVerificationLLMModelChange($event.target.value)"
                aria-label="Verification agent LLM"
              >
                <option value="">{{ sameAsCurrentAiLabel }}</option>
                <option v-for="model in verificationModelOptions" :key="model.id" :value="model.id">{{ getLlmModelLabel(model) }}</option>
              </select>
            </div>
          </div>
          <div class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.vectorDbQueriesLimitLabel', 'Generated search queries') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.vectorDbQueriesLimitTooltip.title', 'Vector DB query count') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.vectorDbQueriesLimitTooltip.description', 'How many search queries the agent generates and sends to the knowledge base per user message.') }}</p>
                </ToolTip>
              </div>
              <input
                type="number"
                min="1"
                :max="vectorDbQueriesLimitInputMax"
                :value="vectorDbQueriesLimitLocal"
                @input="onVectorDbQueriesLimitInput($event.target.value)"
                class="input input-bordered w-28 text-right"
                :placeholder="t('aiChatAgentSetup.advanced.vectorDbQueriesLimitPlaceholder', 'e.g. 3')"
                aria-label="Generated search queries"
              />
            </div>
          </div>
          <div class="form-control w-full mt-4">
            <div class="flex items-center">
              <span>{{ t('aiChatAgentSetup.advanced.vectorQueryAdditionalTextLabel', 'Additional vector query instructions') }}</span>
              <ToolTip class="ml-2" position="right">
                <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.vectorQueryAdditionalTextTooltip.title', 'Agent-specific retrieval guidance') }}</h2>
                <p class="text-xs">{{ t('aiChatAgentSetup.advanced.vectorQueryAdditionalTextTooltip.description', 'Optional instructions added only to this agent search-query prompt. Other agents are not affected.') }}</p>
              </ToolTip>
            </div>
            <textarea
              :value="vectorQueryAdditionalText"
              @input="onVectorQueryAdditionalTextInput($event.target.value)"
              class="textarea textarea-bordered w-full mt-2"
              rows="4"
              :placeholder="t('aiChatAgentSetup.advanced.vectorQueryAdditionalTextPlaceholder', 'Example: For entitlement questions, include the service, age group and insurance plan.')"
            ></textarea>
            <label class="label cursor-pointer justify-start mt-2">
              <input
                type="checkbox"
                class="checkbox"
                :checked="prependHistoryToShortVectorQueries === true"
                @change="onPrependHistoryToShortVectorQueriesChange($event.target.checked)"
              />
              <span class="ml-3">{{ t('aiChatAgentSetup.advanced.prependHistoryToShortVectorQueriesLabel', 'Add recent user context to short follow-up searches') }}</span>
            </label>
          </div>
          <div class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.retrievalStrategyLabel', 'Retrieval strategy') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.retrievalStrategyTooltip.title', 'Knowledge retrieval strategy') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.retrievalStrategyTooltip.description', 'Balanced multi-entity retrieval separates unit codes into independent searches and preserves results for every entity. It can increase response time. Standard keeps the existing retrieval behavior.') }}</p>
                </ToolTip>
              </div>
              <select
                class="select select-bordered w-64 text-right"
                :value="retrievalStrategyLocal"
                @change="onRetrievalStrategyChange($event.target.value)"
                aria-label="Retrieval strategy"
              >
                <option value="auto">{{ t('aiChatAgentSetup.advanced.retrievalStrategyAuto', 'Auto (recommended)') }}</option>
                <option value="standard">{{ t('aiChatAgentSetup.advanced.retrievalStrategyStandard', 'Standard') }}</option>
                <option value="multiEntity">{{ t('aiChatAgentSetup.advanced.retrievalStrategyMultiEntity', 'Balanced multi-entity (always)') }}</option>
              </select>
            </div>
          </div>
          <div class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.kbToolUseModeLabel', 'KB tool use mode') }}</span>
              </div>
              <select
                class="select select-bordered w-40 text-right"
                :value="kbToolUseModeLocal"
                @change="onKbToolUseModeChange($event.target.value)"
                aria-label="KB tool use mode"
              >
                <option value="auto">{{ t('aiChatAgentSetup.advanced.kbToolUseModeAuto', 'Auto') }}</option>
                <option value="always">{{ t('aiChatAgentSetup.advanced.kbToolUseModeAlways', 'Always') }}</option>
              </select>
            </div>
          </div>
          </div>
          <div class="form-control w-full">
            <textarea
              v-model="additionalDescriptionLocal"
              class="textarea textarea-bordered w-full hidden"
              aria-label="Additional description"
            ></textarea>
          </div>
          <div v-if="props.showTransferActions === true" class="form-control w-full mt-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span>{{ t('aiChatAgentSetup.advanced.allowCallControlLabel', 'Allow call transfer and end call') }}</span>
                <ToolTip class="ml-2" position="right">
                  <h2 class="card-title text-sm">{{ t('aiChatAgentSetup.advanced.allowCallControlTooltip.title', 'Call control tools') }}</h2>
                  <p class="text-xs">{{ t('aiChatAgentSetup.advanced.allowCallControlTooltip.description', 'When enabled, the phone agent can transfer the live call or end it according to the rules in the agent description.') }}</p>
                </ToolTip>
              </div>
              <input
                type="checkbox"
                :checked="allowCallControlLocal"
                @change.stop="onAllowCallControlChange"
                class="toggle toggle-primary"
                aria-label="Allow call transfer and end call"
              />
            </div>
          </div>
          <div v-if="props.showTransferActions === true" class="w-full border border-base-300 rounded-box p-4 mt-4">
            <div class="text-base font-semibold mb-3">{{ t('aiChatAgentSetup.knowledgeBase.advanced.transfer', 'Transfer') }}</div>
            <div class="flex flex-col">
              <button class="btn w-full mb-2" @click="emit('export-agent')">{{ t('aiChatAgentSetup.knowledgeBase.advanced.exportAgentZip', 'Export Agent') }}</button>
              <button class="btn w-full" @click="emit('import-agent')">{{ t('aiChatAgentSetup.knowledgeBase.advanced.importAgentZip', 'Import Agent') }}</button>
            </div>
          </div>
        </div>
      </section>
      <section
        id="advanced-response-filters"
        v-show="selectedTab === 'responseFilters'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box text-left"
        dir="ltr"
        :style="{ minHeight: contentMinHeight }"
      >
        <ResponseFiltersBuilder
          :model-value="props.responseFilters"
          :allow-replace-string-filter="true"
          @update:modelValue="onResponseFiltersUpdate"
        />
      </section>
      <section
        id="advanced-vector-db"
        v-if="showVectorDbTab === true"
        v-show="selectedTab === 'vectorDb'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.vectorDbTitle', 'Vector Database') }}</h2>
        <div class="grid max-w-xl grid-space-4">
          <div class="form-control">
            <label class="label">
              <span class="label-text">{{ t('aiChatAgentSetup.advanced.vectorDbProvider', 'Vector DB Provider') }}</span>
            </label>
            <select class="select select-bordered" :value="selectedVectorDbIdLocal" @change="onVectorDbChange($event.target.value)">
              <option v-for="db in availableVectorDBs" :key="db.id" :value="db.id">{{ db.provider }} - {{ db.product }} ({{ db.id }})</option>
            </select>
          </div>
          <div class="form-control" id="embedding-selector-div" v-if="props.hideEmbeddingSelector !== true">
            <label class="label">
              <span class="label-text">{{ t('aiChatAgentSetup.advanced.embeddingModel', 'Embedding Model') }}</span>
            </label>
            <select class="select select-bordered" :value="selectedEmbeddingModelIdLocal" @change="onEmbeddingModelChange($event.target.value)">
              <option v-for="em in availableEmbeddingModels" :key="em.id" :value="em.id">{{ em.provider }} - {{ em.productVariant || em.product }} ({{ em.id }})</option>
            </select>
          </div>
        </div>
      </section>
      <section
        id="advanced-bug-fixing"
        v-show="selectedTab === 'bugFixing'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <div class="flex flex-wrap items-start justify-between">
          <div class="mr-4 mb-4">
            <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.bugFixingStuckFilesTitle', 'Stuck vector index files') }}</h2>
            <p class="text-sm text-gray-500">{{ t('aiChatAgentSetup.advanced.bugFixingStuckFilesDescription', 'Scan the selected vector storage for indexed files and websites that are no longer present in this agent knowledge base.') }}</p>
          </div>
          <button type="button" class="btn mb-4" :disabled="bugFixingScanDisabled === true" @click="scanStaleVectorSources">
            <span v-if="isBugFixingLoading === true" class="loading loading-spinner loading-sm mr-2"></span>
            {{ isBugFixingLoading === true ? t('aiChatAgentSetup.advanced.bugFixingScanning', 'Scanning...') : t('aiChatAgentSetup.advanced.bugFixingScan', 'Scan index') }}
          </button>
        </div>

        <div class="mb-4 text-sm text-base-content/70">
          <span class="font-medium">{{ t('aiChatAgentSetup.advanced.bugFixingSelectedStorage', 'Selected vector storage') }}:</span>
          <span class="ml-2">{{ selectedBugFixingVectorLabel }}</span>
        </div>

        <div v-if="currentBugFixingAgentId.length === 0" class="alert alert-warning">
          <span>{{ t('aiChatAgentSetup.advanced.bugFixingSaveFirst', 'Save the agent first, then scan its vector index from edit mode.') }}</span>
        </div>

        <div v-if="bugFixingError.length > 0" class="alert alert-error mb-4">
          <span>{{ bugFixingError }}</span>
        </div>

        <div v-if="isBugFixingLoading === true && staleVectorSources.length === 0" class="py-6 text-sm text-base-content/70">
          {{ t('aiChatAgentSetup.advanced.bugFixingInspecting', 'Inspecting this agent vector index...') }}
        </div>

        <div v-else-if="bugFixingScanned === true && bugFixingError.length === 0 && staleVectorSources.length === 0" class="alert alert-success">
          <span>{{ t('aiChatAgentSetup.advanced.bugFixingNoStaleFiles', 'No stuck files were found in the selected vector index.') }}</span>
        </div>

        <div v-else-if="staleVectorSources.length > 0" class="overflow-x-auto">
          <table class="table table-zebra">
            <thead>
              <tr>
                <th>{{ t('aiChatAgentSetup.advanced.bugFixingSource', 'Source') }}</th>
                <th>{{ t('aiChatAgentSetup.advanced.bugFixingType', 'Type') }}</th>
                <th>{{ t('aiChatAgentSetup.advanced.bugFixingIndexedEntries', 'Indexed entries') }}</th>
                <th>{{ t('aiChatAgentSetup.advanced.bugFixingSampleItems', 'Sample indexed items') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in staleVectorSources" :key="buildStaleVectorSourceKey(item)">
                <td class="max-w-xl break-all">{{ item.source }}</td>
                <td>{{ item.sourceType === 'website' ? t('aiChatAgentSetup.advanced.bugFixingWebsite', 'Website') : t('aiChatAgentSetup.advanced.bugFixingFile', 'File') }}</td>
                <td>{{ formatBugFixingCount(item.indexedEntries) }}</td>
                <td class="max-w-md break-all">{{ formatBugFixingSampleItems(item.sampleIndexedItems) }}</td>
                <td class="text-right">
                  <button type="button" class="btn btn-xs btn-error" :disabled="isStaleVectorSourceDeletePending(item) === true" @click="deleteStaleVectorSource(item)">
                    {{ isStaleVectorSourceDeletePending(item) === true ? t('aiChatAgentSetup.advanced.bugFixingDeleting', 'Deleting...') : t('aiChatAgentSetup.advanced.bugFixingDelete', 'Delete from index') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section
        id="advanced-starting-buttons"
        v-show="selectedTab === 'startingButtons'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.startingButtonsTitle', 'Starting Buttons') }}</h2>
        <p class="text-sm text-gray-500 mb-4">{{ t('aiChatAgentSetup.advanced.startingButtonsDescription', 'Add up to 4 buttons shown with the first agent message.') }}</p>

        <div class="grid max-w-2xl grid-space-4">
          <div v-for="(btn, idx) in startingButtonsState" :key="idx" class="p-4 border border-base-300 rounded-box bg-white">
            <div class="grid grid-space-3">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">{{ t('aiChatAgentSetup.advanced.buttonLabel', 'Label') }}</span>
                </label>
                <input
                  type="text"
                  :value="btn.label"
                  @input="onStartingButtonLabelInput(idx, $event.target.value)"
                  class="input input-bordered"
                  :placeholder="t('aiChatAgentSetup.advanced.buttonLabelPlaceholder', 'e.g. Help me get started')"
                  aria-label="Starting button label"
                />
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">{{ t('aiChatAgentSetup.advanced.buttonType', 'Type') }}</span>
                </label>
                <select
                  class="select select-bordered"
                  :value="btn.type"
                  @change="onStartingButtonTypeChange(idx, $event.target.value)"
                  aria-label="Starting button type"
                >
                  <option value="Text">{{ t('aiChatAgentSetup.advanced.typeText', 'Text') }}</option>
                  <option value="URL">{{ t('aiChatAgentSetup.advanced.typeURL', 'URL') }}</option>
                </select>
              </div>

              <div v-if="btn.type === 'URL'" class="form-control">
                <label class="label">
                  <span class="label-text">{{ t('aiChatAgentSetup.advanced.buttonUrl', 'URL') }}</span>
                </label>
                <input
                  type="text"
                  :value="btn.action"
                  @input="onStartingButtonActionInput(idx, $event.target.value)"
                  class="input input-bordered"
                  :placeholder="t('aiChatAgentSetup.advanced.buttonUrlPlaceholder', 'https://example.com')"
                  aria-label="Starting button URL"
                />
              </div>

              <div class="flex justify-end">
                <button type="button" class="btn btn-xs btn-error" @click="removeStartingButton(idx)">{{ t('common.remove', 'Remove') }}</button>
              </div>
            </div>
          </div>

          <div class="flex justify-start">
            <button type="button" class="btn" :disabled="startingButtonsState.length >= 4" @click="addStartingButton()">
              {{ t('aiChatAgentSetup.advanced.addButton', 'Add button') }}
            </button>
            <span class="ml-3 self-center text-xs text-gray-500">{{ startingButtonsState.length }} / 4</span>
          </div>
        </div>
      </section>
      <section
        id="advanced-omni"
        v-show="selectedTab === 'omni'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <h2 class="text-lg md:text-xl font-semibold mb-2">{{ t('aiChatAgentSetup.advanced.omniTitle', 'Omni Settings') }}</h2>
        <div class="grid max-w-2xl grid-space-4">
          <div class="form-control">
            <label class="label">
              <span class="label-text">{{ t('aiChatAgentSetup.agentInformation.whatsappClosingMessageLabel', 'Closing message for WhatsApp') }}</span>
            </label>
            <input
              type="text"
              v-model="whatsappClosingMessageModel"
              class="input input-bordered"
              maxlength="300"
              :placeholder="t('aiChatAgentSetup.agentInformation.whatsappClosingMessagePlaceholder', 'This conversation is now closed.')"
              aria-label="WhatsApp closing message"
            />
          </div>
        </div>
      </section>
      <section
        id="advanced-prompt-versions"
        v-show="selectedTab === 'promptVersions'"
        role="tabpanel"
        class="p-4 md:p-6 bg-base-100 border border-base-300 rounded-box"
        :style="{ minHeight: contentMinHeight }"
      >
        <h2 class="text-lg md:text-xl font-semibold mb-2 flex items-center">
          <Icon icon="heroicons-outline:rectangle-stack" class="w-5 h-5 md:w-6 md:h-6 mr-2 flex-shrink-0" />
          <span>{{ t('aiChatAgentSetup.advanced.promptVersionsTitle', 'Prompt Versions') }}</span>
        </h2>
        <p class="text-sm text-gray-500 mb-4">{{ t('aiChatAgentSetup.advanced.promptVersionsDescription', 'Every save stores a dated snapshot of the agent prompt.') }}</p>
        <div v-if="normalizedPromptVersions.length === 0" class="p-4 bg-white border border-base-300 rounded-box text-sm text-gray-500">
          {{ t('aiChatAgentSetup.advanced.noPromptVersions', 'No prompt versions saved yet.') }}
        </div>
        <div v-else class="flex flex-col">
          <div v-for="version in normalizedPromptVersions" :key="version.id" class="p-4 mb-3 bg-white border border-base-300 rounded-box">
            <div class="flex items-start justify-between">
              <div>
                <div class="font-medium text-base-content">{{ formatPromptVersionDate(version) }}</div>
                <div class="text-xs text-gray-500">{{ version.promptLength }} {{ t('reports.charsSuffix', 'chars') }}</div>
              </div>
              <button type="button" class="btn" @click="emit('restore-prompt-version', version)">
                {{ t('aiChatAgentSetup.advanced.restorePromptVersion', 'Restore') }}
              </button>
            </div>
            <pre class="mt-3 p-3 bg-base-200 rounded text-xs whitespace-pre-wrap max-h-40 overflow-auto">{{ getPromptVersionPreview(version) }}</pre>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
import { useI18n } from '@/i18n';
import { Icon } from '@iconify/vue/dist/offline';
import ToolTip from './Tooltip.vue';
import ResponseFiltersBuilder from './ResponseFiltersBuilder.vue';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { globalState } from '@/globalState.js';
const props = defineProps({
  agentId: { type: String, required: false, default: '' },
  languages: { type: Array, required: true },
  retrieveUserLocation: { type: Boolean, required: true },
  enableFileUploadInChat: { type: Boolean, required: true },
  enableUserFineTune: { type: Boolean, required: false, default: false },
  inappropriateContentMessage: { type: Object, required: true },
  dontKnowMessage: { type: Object, required: true },
  networkErrorMessage: { type: Object, required: false, default: () => ({}) },
    makeLinksClickable: { type: Boolean, required: false, default: true },
    clearSessionOnRefresh: { type: Boolean, required: true },
    enabledSavedSessionHistory: { type: Boolean, required: false, default: false },
    regularOpenAiContentFilterFailoverEnabled: { type: Boolean, required: false, default: false },
    showRegularOpenAiContentFilterFailover: { type: Boolean, required: false, default: false },
    showMap: { type: Boolean, required: false, default: true },
    messageLimitPerConversation: { type: [Number, String], required: false, default: 0 },
    messageLimitPerIP: { type: [Number, String], required: false, default: 0 },
    enablePIIRedaction: { type: Boolean, required: false, default: false },
    redactEmails: { type: Boolean, required: false, default: true },
    redactPhoneNumbers: { type: Boolean, required: false, default: false },
    verifyLinks: { type: Boolean, required: false, default: true },
    verifyAnswerEnabled: { type: Boolean, required: false, default: false },
    customBlockRegex: { type: Array, required: false, default: () => [] },
    limitReachedMessage: { type: String, required: false, default: '' },
    retrieverKValue: { type: [Number, String], required: false, default: 30 },
    vectorDbQueriesLimit: { type: [Number, String], required: false, default: 3 },
    vectorQueryAdditionalText: { type: String, required: false, default: '' },
    prependHistoryToShortVectorQueries: { type: Boolean, required: false, default: false },
    maxOutputTokens: { type: [Number, String], required: false, default: 2048 },
    kbToolUseMode: { type: String, required: false, default: 'auto' },
    retrievalStrategy: { type: String, required: false, default: 'standard' },
    availableLLMModels: { type: Array, required: false, default: () => [] },
    currentLlmModelId: { type: String, required: false, default: '' },
    selectedVerificationLLMModel: { type: String, required: false, default: '' },
    responseFilters: { type: Array, required: false, default: () => [] },
    actionButtons: { type: Array, required: false, default: () => [] },
    whatsappClosingMessage: { type: String, required: false, default: '' },
    limitMessagesPerConversationEnabled: { type: Boolean, required: false, default: false },
    limitMessagesPerIPEnabled: { type: Boolean, required: false, default: false },
    selectedVectorDBId: { type: String, required: false, default: '' },
    selectedEmbeddingModelId: { type: String, required: false, default: '' },
    hideEmbeddingSelector: { type: Boolean, required: false, default: false },
    isVoiceOnly: { type: Boolean, required: false, default: false },
    showAllFields: { type: Boolean, required: false, default: false },
  authenticatorEnabled: { type: Boolean, required: false, default: false },
  authenticatorProvider: { type: String, required: false, default: 'google' },
  authenticatorWelcomeMessage: { type: String, required: false, default: 'Welcome! Please sign in at {{authURL}} to continue.' },
  authenticatorRetryMessage: { type: String, required: false, default: 'To continue please login via {{authURL}}.' },
  authenticatorSuccessMessage: { type: String, required: false, default: 'You are signed in. You can return to the conversation.' },
  authenticatorRunAiToolOnLogin: { type: Boolean, required: false, default: false },
  additionalDescription: { type: String, required: false, default: '' },
  allowCallControl: { type: Boolean, required: false, default: false },
  showTransferActions: { type: Boolean, required: false, default: false },
  promptVersions: { type: Array, required: false, default: () => [] },
});

const emit = defineEmits([
  'update:retrieveUserLocation',
  'update:enableFileUploadInChat',
  'update:enableUserFineTune',
  'update:inappropriateContentMessage',
  'update:dontKnowMessage',
  'update:networkErrorMessage',
    'update:makeLinksClickable',
    'update:clearSessionOnRefresh',
    'update:enabledSavedSessionHistory',
    'update:regularOpenAiContentFilterFailoverEnabled',
    'update:showMap',
    'update:messageLimitPerConversation',
    'update:messageLimitPerIP',
    'update:enablePIIRedaction',
    'update:redactEmails',
    'update:redactPhoneNumbers',
    'update:verifyLinks',
    'update:verifyAnswerEnabled',
    'update:customBlockRegex',
    'update:limitReachedMessage',
    'update:retrieverKValue',
    'update:vectorDbQueriesLimit',
    'update:vectorQueryAdditionalText',
    'update:prependHistoryToShortVectorQueries',
    'update:maxOutputTokens',
    'update:kbToolUseMode',
    'update:retrievalStrategy',
    'update:selectedVerificationLLMModel',
    'update:responseFilters',
    'update:actionButtons',
    'update:whatsappClosingMessage',
    'update:limitMessagesPerConversationEnabled',
    'update:limitMessagesPerIPEnabled',
    'update:selectedVectorDBId',
    'update:selectedEmbeddingModelId',
  'update:authenticatorEnabled',
  'update:authenticatorProvider',
  'update:authenticatorWelcomeMessage',
  'update:authenticatorRetryMessage',
  'update:authenticatorSuccessMessage',
  'update:authenticatorRunAiToolOnLogin',
  'update:additionalDescription',
  'update:allowCallControl',
  'restore-prompt-version',
  'export-agent',
  'import-agent',
]);

const { t, currentLanguage } = useI18n();
const isRtl = computed(() => currentLanguage.value === 'he' || currentLanguage.value === 'ar');
const toast = useToast();

const selectedTab = ref('extra');
const isBugFixingLoading = ref(false);
const bugFixingError = ref('');
const bugFixingScanned = ref(false);
const staleVectorSources = ref([]);
const bugFixingVectorDatabase = ref(null);
const staleVectorSourceDeletePendingKeys = ref([]);
let bugFixingScanSequence = 0;
const availableVectorDBs = ref([]);
const availableEmbeddingModels = ref([]);
const authenticatorWelcomeDefault = 'Welcome! Please sign in at {{authURL}} to continue.';
const authenticatorRetryDefault = 'To continue please login via {{authURL}}.';
const authenticatorSuccessDefault = 'You are signed in. Lets talk.';
const authProviderStatuses = ref({});
const authStatusLoading = ref(false);
const retrieveUserLocationLocal = ref(props.retrieveUserLocation === true);
const showMapLocal = ref(props.showMap !== false);
const enableFileUploadInChatLocal = ref(props.enableFileUploadInChat === true);
const makeLinksClickableLocal = ref(props.makeLinksClickable !== false);
const enableUserFineTuneLocal = ref(props.enableUserFineTune === true);
const clearSessionOnRefreshLocal = ref(props.clearSessionOnRefresh === true);
const enabledSavedSessionHistoryLocal = ref(props.enabledSavedSessionHistory === true);
const regularOpenAiContentFilterFailoverEnabledLocal = ref(props.regularOpenAiContentFilterFailoverEnabled === true);
const allowCallControlLocal = ref(props.allowCallControl === true);
const isStandardSubscription = computed(() => {
  const subscription = typeof globalState.userInfo?.subscription === 'string' ? globalState.userInfo.subscription.trim().toLowerCase() : '';
  return subscription === 'standard';
});
const subscriptionAgentsSetupConfig = computed(() => {
  const rawUserInfo = globalState.userInfo;
  if (rawUserInfo === null || rawUserInfo === undefined) {
    return {};
  }
  const rawConfig = rawUserInfo.subscriptionConfig;
  if (typeof rawConfig !== 'object' || rawConfig === null) {
    return {};
  }
  if (typeof rawConfig.agentsSetup === 'object' && rawConfig.agentsSetup !== null) {
    return rawConfig.agentsSetup;
  }
  return rawConfig;
});
const subscriptionFeatureHideConfig = computed(() => {
  const hideConfig = subscriptionAgentsSetupConfig.value?.features?.hide;
  if (typeof hideConfig === 'object' && hideConfig !== null) {
    return hideConfig;
  }
  return {};
});
const subscriptionLimits = computed(() => {
  const limitsConfig = subscriptionAgentsSetupConfig.value?.limits;
  if (typeof limitsConfig === 'object' && limitsConfig !== null) {
    return limitsConfig;
  }
  return {};
});
const showVectorDbTab = computed(() => {
  if (props.showAllFields === true) {
    return true;
  }
  if (subscriptionFeatureHideConfig.value.vectorDb === true || subscriptionFeatureHideConfig.value.vectorDbSelector === true) {
    return false;
  }
  if (isStandardSubscription.value === true) {
    return false;
  }
  return true;
});
const retrieverKValuePolicyMax = computed(() => {
  const rawLimit = subscriptionLimits.value.maxRetrieverKValue;
  const parsedLimit = Number(rawLimit);
  if (Number.isFinite(parsedLimit) === true && parsedLimit >= 1) {
    return parsedLimit;
  }
  if (isStandardSubscription.value === true) {
    return 6;
  }
  return 0;
});
const retrieverKValueInputMax = computed(() => retrieverKValuePolicyMax.value > 0 ? retrieverKValuePolicyMax.value : 14);
const maxOutputTokensPolicyMax = computed(() => {
  const rawLimit = subscriptionLimits.value.maxOutputTokens;
  const parsedLimit = Number(rawLimit);
  if (Number.isFinite(parsedLimit) === true && parsedLimit >= 1) {
    return parsedLimit;
  }
  if (isStandardSubscription.value === true) {
    return 2048;
  }
  return 0;
});
const maxOutputTokensInputMax = computed(() => maxOutputTokensPolicyMax.value > 0 ? maxOutputTokensPolicyMax.value : undefined);
const vectorDbQueriesLimitInputMax = 10;
const selectedVectorDbIdLocal = computed(() => typeof props.selectedVectorDBId === 'string' ? props.selectedVectorDBId : '');
const selectedEmbeddingModelIdLocal = computed(() => typeof props.selectedEmbeddingModelId === 'string' ? props.selectedEmbeddingModelId : '');
const currentBugFixingAgentId = computed(() => typeof props.agentId === 'string' ? props.agentId.trim() : '');
const selectedBugFixingVectorLabel = computed(() => {
  const selectedId = selectedVectorDbIdLocal.value;
  for (let index = 0; index < availableVectorDBs.value.length; index = index + 1) {
    const vectorDatabase = availableVectorDBs.value[index];
    if (vectorDatabase !== undefined && vectorDatabase !== null && vectorDatabase.id === selectedId) {
      const provider = typeof vectorDatabase.provider === 'string' ? vectorDatabase.provider : '';
      const product = typeof vectorDatabase.product === 'string' ? vectorDatabase.product : '';
      const label = `${provider} ${product}`.trim();
      return label.length > 0 ? `${label} (${selectedId})` : selectedId;
    }
  }
  const inspectedVectorDatabase = bugFixingVectorDatabase.value;
  if (inspectedVectorDatabase !== null && typeof inspectedVectorDatabase === 'object') {
    const provider = typeof inspectedVectorDatabase.provider === 'string' ? inspectedVectorDatabase.provider : '';
    const product = typeof inspectedVectorDatabase.product === 'string' ? inspectedVectorDatabase.product : '';
    const id = typeof inspectedVectorDatabase.id === 'string' ? inspectedVectorDatabase.id : '';
    const label = `${provider} ${product}`.trim();
    if (label.length > 0 && id.length > 0) {
      return `${label} (${id})`;
    }
    if (label.length > 0) {
      return label;
    }
    if (id.length > 0) {
      return id;
    }
  }
  return selectedId.length > 0 ? selectedId : t('aiChatAgentSetup.advanced.bugFixingNoStorage', 'No vector storage selected');
});
const bugFixingScanDisabled = computed(() => {
  if (isBugFixingLoading.value === true) {
    return true;
  }
  if (currentBugFixingAgentId.value.length === 0) {
    return true;
  }
  return false;
});
watch([currentBugFixingAgentId, selectedVectorDbIdLocal, selectedEmbeddingModelIdLocal], () => {
  bugFixingScanSequence = bugFixingScanSequence + 1;
  isBugFixingLoading.value = false;
  bugFixingError.value = '';
  bugFixingScanned.value = false;
  staleVectorSources.value = [];
  bugFixingVectorDatabase.value = null;
  staleVectorSourceDeletePendingKeys.value = [];
});
watch(() => props.retrieveUserLocation, (value) => {
  retrieveUserLocationLocal.value = value === true;
});

watch(() => props.showMap, (value) => {
  showMapLocal.value = value !== false;
});

watch(() => props.enableFileUploadInChat, (value) => {
  enableFileUploadInChatLocal.value = value === true;
});

watch(() => props.makeLinksClickable, (value) => {
  makeLinksClickableLocal.value = value !== false;
});

watch(() => props.enableUserFineTune, (value) => {
  enableUserFineTuneLocal.value = value === true;
});

watch(() => props.clearSessionOnRefresh, (value) => {
  clearSessionOnRefreshLocal.value = value === true;
});

watch(() => props.enabledSavedSessionHistory, (value) => {
  enabledSavedSessionHistoryLocal.value = value === true;
});

watch(() => props.regularOpenAiContentFilterFailoverEnabled, (value) => {
  regularOpenAiContentFilterFailoverEnabledLocal.value = value === true;
});

watch(() => props.allowCallControl, (value) => {
  allowCallControlLocal.value = value === true;
});

function normalizeRetrieverKValue(value) {
  const fallback = retrieverKValuePolicyMax.value > 0 ? retrieverKValuePolicyMax.value : 30;
  const n = Number(value);
  const candidate = Number.isFinite(n) === true && n >= 1 ? n : fallback;
  if (retrieverKValuePolicyMax.value > 0 && candidate > retrieverKValuePolicyMax.value) {
    return retrieverKValuePolicyMax.value;
  }
  return candidate;
}

function normalizeMaxOutputTokens(value) {
  const fallback = maxOutputTokensPolicyMax.value > 0 ? maxOutputTokensPolicyMax.value : 512;
  const n = Number(value);
  const candidate = Number.isFinite(n) === true && n >= 1 ? n : fallback;
  if (maxOutputTokensPolicyMax.value > 0 && candidate > maxOutputTokensPolicyMax.value) {
    return maxOutputTokensPolicyMax.value;
  }
  return candidate;
}

function normalizeVectorDbQueriesLimit(value) {
  const n = Number(value);
  const candidate = Number.isFinite(n) === true && n >= 1 ? Math.floor(n) : 3;
  if (candidate > vectorDbQueriesLimitInputMax) {
    return vectorDbQueriesLimitInputMax;
  }
  return candidate;
}

async function loadVectorDbAndEmbeddings() {
  try {
    const endpoint = globalState.apiEndpoint;
    const [vecRes, embRes] = await Promise.all([
      axios.get(`${endpoint}/api/config/vectorDBs`),
      axios.get(`${endpoint}/api/config/embeddingModels`),
    ]);
    availableVectorDBs.value = Array.isArray(vecRes.data) === true ? vecRes.data : [];
    availableEmbeddingModels.value = Array.isArray(embRes.data) === true ? embRes.data : [];
    if ((props.selectedVectorDBId === undefined || props.selectedVectorDBId === null || props.selectedVectorDBId === '') && availableVectorDBs.value.length > 0) {
      const azureVector = availableVectorDBs.value.find(db => (typeof db.provider === 'string' ? db.provider.toLowerCase() : '') === 'azure');
      if (azureVector !== undefined && azureVector !== null && typeof azureVector.id === 'string' && azureVector.id !== '') {
        emit('update:selectedVectorDBId', azureVector.id);
      } else {
        emit('update:selectedVectorDBId', availableVectorDBs.value[0].id);
      }
    }
  } catch (e) {
    availableVectorDBs.value = [];
    availableEmbeddingModels.value = [];
  }
}
async function loadAuthProviderStatuses() {
  authStatusLoading.value = true;
  try {
    const endpoint = globalState.apiEndpoint;
    const res = await axios.get(`${endpoint}/agents/auth/providers/status`);
    if (res !== undefined && res !== null && typeof res.data === 'object') {
      authProviderStatuses.value = res.data;
    } else {
      authProviderStatuses.value = {};
    }
  } catch (e) {
    authProviderStatuses.value = {};
  } finally {
    authStatusLoading.value = false;
  }
}

function getAuthToken() {
  if (globalState.authUsesHttpOnlyCookies === true) {
    return '';
  }
  if (typeof document === 'undefined') {
    return '';
  }
  const cookieRows = document.cookie.split('; ');
  for (let i = 0; i < cookieRows.length; i = i + 1) {
    const row = cookieRows[i];
    if (row.startsWith('authToken=') === true) {
      const parts = row.split('=');
      if (parts.length > 1) {
        return parts[1];
      }
    }
  }
  return '';
}

function getAuthHeaders() {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json'
  };
  if (token !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

function getAuthenticatedAxiosConfig(extraConfig) {
  const cfg = extraConfig !== undefined && extraConfig !== null && typeof extraConfig === 'object' ? { ...extraConfig } : {};
  const headers = getAuthHeaders();
  cfg.headers = headers;
  const authHeader = headers.Authorization;
  let hasAuthHeader = false;
  if (typeof authHeader === 'string') {
    if (authHeader.trim().length > 0) {
      hasAuthHeader = true;
    }
  }
  if (hasAuthHeader !== true) {
    cfg.withCredentials = true;
  }
  return cfg;
}

function getBugFixingErrorMessage(error) {
  const responseData = error?.response?.data;
  if (responseData !== undefined && responseData !== null && typeof responseData.message === 'string' && responseData.message.length > 0) {
    return responseData.message;
  }
  if (responseData !== undefined && responseData !== null && typeof responseData.error === 'string' && responseData.error.length > 0) {
    return responseData.error;
  }
  if (error !== undefined && error !== null && typeof error.message === 'string' && error.message.length > 0) {
    return error.message;
  }
  return t('aiChatAgentSetup.advanced.bugFixingLoadFailed', 'Failed to inspect the selected vector index.');
}

function buildStaleVectorSourceKey(item) {
  const source = item !== undefined && item !== null && typeof item.source === 'string' ? item.source : '';
  return `${currentBugFixingAgentId.value}:${source}`;
}

function isStaleVectorSourceDeletePending(item) {
  return staleVectorSourceDeletePendingKeys.value.includes(buildStaleVectorSourceKey(item)) === true;
}

function formatBugFixingCount(value) {
  if (value === null) {
    return '0';
  }
  if (value === undefined) {
    return '0';
  }
  if (Number.isFinite(Number(value)) === false) {
    return '0';
  }
  return new Intl.NumberFormat().format(Number(value));
}

function formatBugFixingSampleItems(items) {
  if (Array.isArray(items) === false) {
    return '--';
  }
  if (items.length === 0) {
    return '--';
  }
  return items.join(', ');
}

async function scanStaleVectorSources() {
  const agentId = currentBugFixingAgentId.value;
  if (agentId.length === 0) {
    bugFixingError.value = t('aiChatAgentSetup.advanced.bugFixingSaveFirst', 'Save the agent first, then scan its vector index from edit mode.');
    bugFixingScanned.value = false;
    return;
  }
  isBugFixingLoading.value = true;
  bugFixingError.value = '';
  bugFixingScanSequence = bugFixingScanSequence + 1;
  const scanSequence = bugFixingScanSequence;
  try {
    const endpoint = globalState.apiEndpoint;
    const safeAgentId = encodeURIComponent(agentId);
    const response = await axios.get(
      `${endpoint}/api/agents/${safeAgentId}/vectorDiagnosis/staleSources`,
      getAuthenticatedAxiosConfig({
        params: {
          selectedVectorDBId: selectedVectorDbIdLocal.value,
          selectedEmbeddingModelId: selectedEmbeddingModelIdLocal.value
        }
      })
    );
    if (scanSequence !== bugFixingScanSequence) {
      return;
    }
    const payload = response !== undefined && response !== null && response.data !== undefined && response.data !== null ? response.data : {};
    staleVectorSources.value = Array.isArray(payload.staleSources) === true ? payload.staleSources : [];
    bugFixingVectorDatabase.value = payload.vectorDatabase !== undefined && payload.vectorDatabase !== null && typeof payload.vectorDatabase === 'object' ? payload.vectorDatabase : null;
    bugFixingScanned.value = true;
  } catch (error) {
    if (scanSequence !== bugFixingScanSequence) {
      return;
    }
    staleVectorSources.value = [];
    bugFixingVectorDatabase.value = null;
    bugFixingScanned.value = true;
    bugFixingError.value = getBugFixingErrorMessage(error);
  } finally {
    if (scanSequence === bugFixingScanSequence) {
      isBugFixingLoading.value = false;
    }
  }
}

function openBugFixingTab() {
  selectedTab.value = 'bugFixing';
  if (bugFixingScanned.value !== true && currentBugFixingAgentId.value.length > 0) {
    scanStaleVectorSources();
  }
}

async function deleteStaleVectorSource(item) {
  const source = item !== undefined && item !== null && typeof item.source === 'string' ? item.source : '';
  if (source.length === 0) {
    toast.error(t('aiChatAgentSetup.advanced.bugFixingInvalidSource', 'Invalid vector source selected.'));
    return;
  }
  const isConfirmed = window.confirm(t('aiChatAgentSetup.advanced.bugFixingDeleteConfirm', `Delete "${source}" from the selected vector index?`));
  if (isConfirmed !== true) {
    return;
  }
  const deleteKey = buildStaleVectorSourceKey(item);
  if (staleVectorSourceDeletePendingKeys.value.includes(deleteKey) === false) {
    staleVectorSourceDeletePendingKeys.value = [...staleVectorSourceDeletePendingKeys.value, deleteKey];
  }
  bugFixingError.value = '';
  try {
    const endpoint = globalState.apiEndpoint;
    const safeAgentId = encodeURIComponent(currentBugFixingAgentId.value);
    const response = await axios.post(
      `${endpoint}/api/agents/${safeAgentId}/vectorDiagnosis/deleteSources`,
      {
        sources: [source],
        selectedVectorDBId: selectedVectorDbIdLocal.value,
        selectedEmbeddingModelId: selectedEmbeddingModelIdLocal.value
      },
      getAuthenticatedAxiosConfig({})
    );
    const payload = response !== undefined && response !== null && response.data !== undefined && response.data !== null ? response.data : {};
    staleVectorSources.value = Array.isArray(payload.staleSources) === true ? payload.staleSources : [];
    bugFixingVectorDatabase.value = payload.vectorDatabase !== undefined && payload.vectorDatabase !== null && typeof payload.vectorDatabase === 'object' ? payload.vectorDatabase : bugFixingVectorDatabase.value;
    bugFixingScanned.value = true;
    toast.success(t('aiChatAgentSetup.advanced.bugFixingDeleteSuccess', `Deleted "${source}" from the selected vector index.`));
  } catch (error) {
    const message = getBugFixingErrorMessage(error);
    bugFixingError.value = message;
    toast.error(message);
  } finally {
    staleVectorSourceDeletePendingKeys.value = staleVectorSourceDeletePendingKeys.value.filter((key) => key !== deleteKey);
  }
}

const selectedSecurityLang = ref('en');
const selectedGuidanceLang = ref('en');
const selectedNetworkErrorLang = ref('en');
const asideRef = ref(null);
const contentMinHeight = ref('16rem');

function recalcContentMinHeight() {
  const asideEl = asideRef.value;
  if (asideEl !== null && asideEl !== undefined) {
    const h = asideEl.offsetHeight;
    contentMinHeight.value = h > 0 ? h + 'px' : '16rem';
  }
}

function handleResize() {
  recalcContentMinHeight();
}

onMounted(async () => {
  await nextTick();
  recalcContentMinHeight();
  window.addEventListener('resize', handleResize);
  await loadVectorDbAndEmbeddings();
  await loadAuthProviderStatuses();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

const currentSecurityMessage = computed({
  get: () => props.inappropriateContentMessage[selectedSecurityLang.value] !== undefined ? props.inappropriateContentMessage[selectedSecurityLang.value] : '',
  set: (value) => {
    const updated = { };
    for (const k in props.inappropriateContentMessage) {
      updated[k] = props.inappropriateContentMessage[k];
    }
    updated[selectedSecurityLang.value] = value;
    emit('update:inappropriateContentMessage', updated);
  },
});

const currentGuidanceMessage = computed({
  get: () => props.dontKnowMessage[selectedGuidanceLang.value] !== undefined ? props.dontKnowMessage[selectedGuidanceLang.value] : '',
  set: (value) => {
    const updated = { };
    for (const k in props.dontKnowMessage) {
      updated[k] = props.dontKnowMessage[k];
    }
    updated[selectedGuidanceLang.value] = value;
    emit('update:dontKnowMessage', updated);
  },
});

const currentNetworkErrorMessage = computed({
  get: () => (props.networkErrorMessage !== undefined && props.networkErrorMessage !== null && props.networkErrorMessage[selectedNetworkErrorLang.value] !== undefined) ? props.networkErrorMessage[selectedNetworkErrorLang.value] : '',
  set: (value) => {
    const updated = { };
    const src = (props.networkErrorMessage !== undefined && props.networkErrorMessage !== null) ? props.networkErrorMessage : {};
    for (const k in src) {
      updated[k] = src[k];
    }
    updated[selectedNetworkErrorLang.value] = value;
    emit('update:networkErrorMessage', updated);
  },
});

const additionalDescriptionLocal = computed({
  get: () => typeof props.additionalDescription === 'string' ? props.additionalDescription : '',
  set: (value) => {
    emit('update:additionalDescription', value);
  },
});

const securityChars = computed(() => currentSecurityMessage.value !== undefined ? currentSecurityMessage.value.length : 0);

const guidanceChars = computed(() => currentGuidanceMessage.value !== undefined ? currentGuidanceMessage.value.length : 0);

const networkErrorChars = computed(() => currentNetworkErrorMessage.value !== undefined ? currentNetworkErrorMessage.value.length : 0);

function normalizePromptVersionItem(item, index) {
  if (item === undefined || item === null || typeof item !== 'object') {
    return null;
  }
  const prompt = typeof item.prompt === 'string' ? item.prompt : '';
  const savedAt = typeof item.savedAt === 'string' && item.savedAt.length > 0 ? item.savedAt : '';
  const savedAtDate = typeof item.savedAtDate === 'string' && item.savedAtDate.length > 0 ? item.savedAtDate : '';
  const savedAtTime = typeof item.savedAtTime === 'string' && item.savedAtTime.length > 0 ? item.savedAtTime : '';
  const id = typeof item.id === 'string' && item.id.length > 0 ? item.id : `prompt-version-${index}`;
  const promptLengthValue = Number(item.promptLength);
  const promptLength = Number.isFinite(promptLengthValue) === true && promptLengthValue >= 0 ? promptLengthValue : prompt.length;
  return {
    id: id,
    prompt: prompt,
    savedAt: savedAt,
    savedAtDate: savedAtDate,
    savedAtTime: savedAtTime,
    promptLength: promptLength
  };
}

const normalizedPromptVersions = computed(() => {
  const source = Array.isArray(props.promptVersions) === true ? props.promptVersions : [];
  const versions = [];
  for (let i = 0; i < source.length; i = i + 1) {
    const version = normalizePromptVersionItem(source[i], i);
    if (version !== null) {
      versions.push(version);
    }
  }
  versions.sort((a, b) => {
    const bTime = Date.parse(b.savedAt);
    const aTime = Date.parse(a.savedAt);
    const safeBTime = Number.isFinite(bTime) === true ? bTime : 0;
    const safeATime = Number.isFinite(aTime) === true ? aTime : 0;
    return safeBTime - safeATime;
  });
  return versions;
});

function formatPromptVersionDate(version) {
  if (version.savedAtDate !== '' && version.savedAtTime !== '') {
    return `${version.savedAtDate} ${version.savedAtTime}`;
  }
  if (version.savedAt !== '') {
    const date = new Date(version.savedAt);
    if (Number.isNaN(date.getTime()) !== true) {
      return date.toLocaleString();
    }
  }
  return t('aiChatAgentSetup.advanced.unknownPromptVersionDate', 'Unknown date');
}

function getPromptVersionPreview(version) {
  if (typeof version.prompt !== 'string') {
    return '';
  }
  if (version.prompt.length <= 1000) {
    return version.prompt;
  }
  return `${version.prompt.substring(0, 1000)}...`;
}

const authenticatorEnabledLocal = computed({
  get: () => props.authenticatorEnabled === true,
  set: (value) => emit('update:authenticatorEnabled', value === true),
});

const authenticatorProviderLocal = computed({
  get: () => {
    const val = typeof props.authenticatorProvider === 'string' ? props.authenticatorProvider : '';
    if (val === undefined || val === null || val === '') return 'google';
    return val;
  },
  set: (value) => emit('update:authenticatorProvider', typeof value === 'string' && value !== '' ? value : 'google'),
});

const authenticatorWelcomeMessageModel = computed({
  get: () => typeof props.authenticatorWelcomeMessage === 'string' && props.authenticatorWelcomeMessage.trim().length > 0 ? props.authenticatorWelcomeMessage : authenticatorWelcomeDefault,
  set: (value) => emit('update:authenticatorWelcomeMessage', typeof value === 'string' ? value : ''),
});

const authenticatorRetryMessageModel = computed({
  get: () => typeof props.authenticatorRetryMessage === 'string' && props.authenticatorRetryMessage.trim().length > 0 ? props.authenticatorRetryMessage : authenticatorRetryDefault,
  set: (value) => emit('update:authenticatorRetryMessage', typeof value === 'string' ? value : ''),
});

const authenticatorSuccessMessageModel = computed({
  get: () => typeof props.authenticatorSuccessMessage === 'string' && props.authenticatorSuccessMessage.trim().length > 0 ? props.authenticatorSuccessMessage : authenticatorSuccessDefault,
  set: (value) => emit('update:authenticatorSuccessMessage', typeof value === 'string' ? value : ''),
});

const authenticatorRunAiToolOnLoginLocal = computed({
  get: () => props.authenticatorRunAiToolOnLogin === true,
  set: (value) => emit('update:authenticatorRunAiToolOnLogin', value === true),
});

const selectedAuthProviderStatus = computed(() => {
  const provider = authenticatorProviderLocal.value;
  const statuses = authProviderStatuses.value;
  if (statuses !== undefined && statuses !== null && typeof statuses === 'object') {
    const status = statuses[provider];
    if (status !== undefined) return status;
  }
  return null;
});

const authNotConfiguredText = computed(() => {
  const status = selectedAuthProviderStatus.value;
  if (status === null) return '';
  if (status.configured === true) return '';
  const missing = Array.isArray(status.missingEnvs) === true ? status.missingEnvs : [];
  const missingText = missing.length > 0 ? missing.join(', ') : '';
  if (authenticatorProviderLocal.value === 'aad') {
    const required = ['azureAdClientId', 'azureAdClientSecret', 'azureAdTenantId', 'azureAdRedirectUrl'];
    const listText = missingText !== '' ? missingText : required.join(', ');
    return `Add ${listText} to the environment and talk with your support team for configuring.`;
  }
  if (missingText !== '') {
    return `Add ${missingText} to the environment and talk with your support team for configuring.`;
  }
  return 'Talk with your support team for configuring this provider.';
});

function onAuthenticatorEnabledChange(value) {
  authenticatorEnabledLocal.value = value === true;
}

function onAuthenticatorProviderChange(value) {
  const val = typeof value === 'string' ? value : 'google';
  authenticatorProviderLocal.value = val;
}

function onAuthenticatorRunToolChange(value) {
  authenticatorRunAiToolOnLoginLocal.value = value === true;
}

function getSwitchChecked(event) {
  const target = event.target;
  if (target !== null && target !== undefined && typeof target.checked === 'boolean') {
    return target.checked;
  }
  return false;
}

function releaseSwitchFocus(event) {
  const target = event.target;
  if (target !== null && target !== undefined && typeof target.blur === 'function') {
    nextTick(() => {
      target.blur();
    });
  }
}

function onRetrieveUserLocationChange(event) {
  const value = getSwitchChecked(event);
  retrieveUserLocationLocal.value = value === true;
  emit('update:retrieveUserLocation', value === true);
  releaseSwitchFocus(event);
}

function onShowMapChange(event) {
  const value = getSwitchChecked(event);
  showMapLocal.value = value === true;
  emit('update:showMap', value === true);
  releaseSwitchFocus(event);
}

function onEnableFileUploadInChatChange(event) {
  const value = getSwitchChecked(event);
  enableFileUploadInChatLocal.value = value === true;
  emit('update:enableFileUploadInChat', value === true);
  releaseSwitchFocus(event);
}

function onEnableUserFineTuneChange(event) {
  const value = getSwitchChecked(event);
  enableUserFineTuneLocal.value = value === true;
  emit('update:enableUserFineTune', value === true);
  releaseSwitchFocus(event);
}

function onMakeLinksClickableChange(event) {
  const value = getSwitchChecked(event);
  makeLinksClickableLocal.value = value === true;
  emit('update:makeLinksClickable', value === true);
  releaseSwitchFocus(event);
}

function onClearSessionOnRefreshChange(event) {
  const value = getSwitchChecked(event);
  clearSessionOnRefreshLocal.value = value === true;
  emit('update:clearSessionOnRefresh', value === true);
  releaseSwitchFocus(event);
}

function onEnabledSavedSessionHistoryChange(event) {
  const value = getSwitchChecked(event);
  enabledSavedSessionHistoryLocal.value = value === true;
  emit('update:enabledSavedSessionHistory', value === true);
  releaseSwitchFocus(event);
}

function onRegularOpenAiContentFilterFailoverEnabledChange(event) {
  const value = getSwitchChecked(event);
  regularOpenAiContentFilterFailoverEnabledLocal.value = value === true;
  emit('update:regularOpenAiContentFilterFailoverEnabled', value === true);
  releaseSwitchFocus(event);
}

function onAllowCallControlChange(event) {
  const value = getSwitchChecked(event);
  allowCallControlLocal.value = value === true;
  emit('update:allowCallControl', value === true);
  releaseSwitchFocus(event);
}

  const messageLimitPerConversationLocal = computed(() => {
    const val = props.messageLimitPerConversation;
    if (val === undefined || val === null) return 0;
    const n = Number(val);
    return Number.isFinite(n) === true && n >= 0 ? n : 0;
  });

  const messageLimitPerIPLocal = computed(() => {
    const val = props.messageLimitPerIP;
    if (val === undefined || val === null) return 0;
    const n = Number(val);
    return Number.isFinite(n) === true && n >= 0 ? n : 0;
  });

  const verifyLinksLocal = computed(() => props.verifyLinks === true);
  const verifyAnswerEnabledLocal = computed(() => props.verifyAnswerEnabled === true);
  const limitMessagesPerConversationEnabledLocal = computed(() => props.limitMessagesPerConversationEnabled === true);
  const limitMessagesPerIPEnabledLocal = computed(() => props.limitMessagesPerIPEnabled === true);

  const customBlockRegexText = computed(() => {
    const arr = Array.isArray(props.customBlockRegex) === true ? props.customBlockRegex : [];
    return arr.join('\n');
  });

  const retrieverKValueLocal = computed(() => {
    return normalizeRetrieverKValue(props.retrieverKValue);
  });

  const maxOutputTokensLocal = computed(() => {
    return normalizeMaxOutputTokens(props.maxOutputTokens);
  });

  const vectorDbQueriesLimitLocal = computed(() => {
    return normalizeVectorDbQueriesLimit(props.vectorDbQueriesLimit);
  });
const verificationModelOptions = computed(() => {
  const list = Array.isArray(props.availableLLMModels) === true ? props.availableLLMModels : [];
  return list.filter(model => {
    const product = typeof model?.product === 'string' ? model.product.toLowerCase() : '';
    const variant = typeof model?.productVariant === 'string' ? model.productVariant.toLowerCase() : '';
    const id = typeof model?.id === 'string' ? model.id.toLowerCase() : '';
    if (product.includes('embedd') === true) {
      return false;
    }
    if (variant.includes('embedd') === true) {
      return false;
    }
    if (id.includes('embedd') === true) {
      return false;
    }
    if (model?.hasAccess === false && model?.id !== props.selectedVerificationLLMModel && model?.id !== props.currentLlmModelId) {
      return false;
    }
    return typeof model?.id === 'string' && model.id.length > 0;
  });
});
const selectedVerificationLLMModelLocal = computed(() => typeof props.selectedVerificationLLMModel === 'string' ? props.selectedVerificationLLMModel : '');
const currentLlmDisplayName = computed(() => {
  const currentModelId = typeof props.currentLlmModelId === 'string' ? props.currentLlmModelId : '';
  if (currentModelId === '') {
    return t('aiChatAgentSetup.advanced.sameCurrentAiFallbackLabel', 'Current AI');
  }
  const match = verificationModelOptions.value.find(model => model.id === currentModelId);
  if (match === undefined || match === null) {
    return t('aiChatAgentSetup.advanced.sameCurrentAiFallbackLabel', 'Current AI');
  }
  return getLlmModelLabel(match);
});
const sameAsCurrentAiLabel = computed(() => `${t('aiChatAgentSetup.advanced.sameAsCurrentAiLabel', 'Same as current AI')} (${currentLlmDisplayName.value})`);
  const kbToolUseModeLocal = computed(() => {
    if (props.kbToolUseMode === 'always') {
      return 'always';
    }
    return 'auto';
  });
  const retrievalStrategyLocal = computed(() => {
    if (props.retrievalStrategy === 'multiEntity') {
      return 'multiEntity';
    }
    if (props.retrievalStrategy === 'auto') {
      return 'auto';
    }
    return 'standard';
  });

  function getLlmModelLabel(model) {
    if (model === undefined || model === null) {
      return '';
    }
    const provider = typeof model.provider === 'string' && model.provider !== '' ? model.provider : 'N/A';
    const modelId = typeof model.id === 'string' && model.id !== '' ? model.id : '';
    const variant = typeof model.productVariant === 'string' && model.productVariant !== '' ? model.productVariant : (modelId !== '' ? modelId : 'N/A');
    const version = typeof model.productVersion === 'string' && model.productVersion !== '' ? model.productVersion : '';
    return `${provider} - ${variant} ${version}`.trim();
  }

  function onVectorDbChange(value) {
    const v = typeof value === 'string' ? value : '';
    emit('update:selectedVectorDBId', v);
  }

  function onEmbeddingModelChange(value) {
    const v = typeof value === 'string' ? value : '';
    emit('update:selectedEmbeddingModelId', v);
  }

  function onMessageLimitPerConversationInput(value) {
    const n = Number(value);
    const v = Number.isFinite(n) === true && n >= 0 ? n : 0;
    emit('update:messageLimitPerConversation', v);
  }

  function onMessageLimitPerIPInput(value) {
    const n = Number(value);
    const v = Number.isFinite(n) === true && n >= 0 ? n : 0;
    emit('update:messageLimitPerIP', v);
  }

  function onLimitMessagesPerConversationEnabledChange(value) {
    const v = value === true;
    emit('update:limitMessagesPerConversationEnabled', v);
    if (v !== true) {
      emit('update:messageLimitPerConversation', 0);
    }
  }

  function onLimitMessagesPerIPEnabledChange(value) {
    const v = value === true;
    emit('update:limitMessagesPerIPEnabled', v);
    if (v !== true) {
      emit('update:messageLimitPerIP', 0);
    }
  }

  function onVerifyLinksChange(value) {
    emit('update:verifyLinks', value === true);
  }

  function onVerifyAnswerEnabledChange(value) {
    emit('update:verifyAnswerEnabled', value === true);
  }

  function onCustomBlockRegexInput(value) {
    if (typeof value !== 'string') {
      emit('update:customBlockRegex', []);
      return;
    }
    const parts = value.split('\n').map(x => x.trim()).filter(x => x.length > 0);
    emit('update:customBlockRegex', parts);
  }

  function onRetrieverKValueInput(value) {
    const v = normalizeRetrieverKValue(value);
    emit('update:retrieverKValue', v);
  }

  function onVectorDbQueriesLimitInput(value) {
    const v = normalizeVectorDbQueriesLimit(value);
    emit('update:vectorDbQueriesLimit', v);
  }

  function onVectorQueryAdditionalTextInput(value) {
    emit('update:vectorQueryAdditionalText', typeof value === 'string' ? value : '');
  }

  function onPrependHistoryToShortVectorQueriesChange(value) {
    emit('update:prependHistoryToShortVectorQueries', value === true);
  }

  function onMaxOutputTokensInput(value) {
    const v = normalizeMaxOutputTokens(value);
    emit('update:maxOutputTokens', v);
  }
  function onKbToolUseModeChange(value) {
    if (value === 'always') {
      emit('update:kbToolUseMode', 'always');
      return;
    }
    emit('update:kbToolUseMode', 'auto');
  }

  function onRetrievalStrategyChange(value) {
    if (value === 'multiEntity') {
      emit('update:retrievalStrategy', 'multiEntity');
      return;
    }
    if (value === 'auto') {
      emit('update:retrievalStrategy', 'auto');
      return;
    }
    emit('update:retrievalStrategy', 'standard');
  }

  function onSelectedVerificationLLMModelChange(value) {
    emit('update:selectedVerificationLLMModel', typeof value === 'string' ? value : '');
  }

  function onResponseFiltersUpdate(value) {
    const next = Array.isArray(value) === true ? value : [];
    emit('update:responseFilters', next);
  }

  const limitReachedMessageModel = computed({
    get: () => typeof props.limitReachedMessage === 'string' ? props.limitReachedMessage : '',
    set: (v) => emit('update:limitReachedMessage', typeof v === 'string' ? v : '')
  });

  const whatsappClosingMessageModel = computed({
    get: () => typeof props.whatsappClosingMessage === 'string' ? props.whatsappClosingMessage : '',
    set: (v) => emit('update:whatsappClosingMessage', typeof v === 'string' ? v : '')
  });

  function normalizeStartingButtons(arr) {
    const src = Array.isArray(arr) === true ? arr : [];
    const out = [];
    for (let i = 0; i < src.length; i = i + 1) {
      const item = src[i] !== undefined && src[i] !== null ? src[i] : {};
      const label = typeof item.label === 'string' ? item.label : '';
      const type = item.type === 'URL' || item.type === 'Text' ? item.type : 'Text';
      const action = typeof item.action === 'string' ? item.action : '';
      out.push({ label: label, type: type, action: action });
      if (out.length >= 4) break;
    }
    return out;
  }

  const startingButtonsState = ref(normalizeStartingButtons(props.actionButtons));

  watch(() => props.actionButtons, (val) => {
    startingButtonsState.value = normalizeStartingButtons(val);
  }, { deep: true });

  function emitStartingButtons(next) {
    const normalized = normalizeStartingButtons(next);
    emit('update:actionButtons', normalized);
  }

  function addStartingButton() {
    const current = normalizeStartingButtons(startingButtonsState.value);
    if (current.length >= 4) return;
    const next = current.concat([{ label: '', type: 'Text', action: '' }]);
    startingButtonsState.value = next;
    emitStartingButtons(next);
  }

  function removeStartingButton(index) {
    const current = normalizeStartingButtons(startingButtonsState.value);
    const next = [];
    for (let i = 0; i < current.length; i = i + 1) {
      if (i !== index) next.push(current[i]);
    }
    startingButtonsState.value = next;
    emitStartingButtons(next);
  }

  function onStartingButtonLabelInput(index, value) {
    const current = normalizeStartingButtons(startingButtonsState.value);
    if (index >= 0 && index < current.length) {
      current[index] = { label: typeof value === 'string' ? value : '', type: current[index].type, action: current[index].action };
      startingButtonsState.value = current;
      emitStartingButtons(current);
    }
  }

  function onStartingButtonTypeChange(index, value) {
    const t = value === 'URL' ? 'URL' : 'Text';
    const current = normalizeStartingButtons(startingButtonsState.value);
    if (index >= 0 && index < current.length) {
      const actionVal = t === 'URL' ? current[index].action : '';
      current[index] = { label: current[index].label, type: t, action: actionVal };
      startingButtonsState.value = current;
      emitStartingButtons(current);
    }
  }

  function onStartingButtonActionInput(index, value) {
    const current = normalizeStartingButtons(startingButtonsState.value);
    if (index >= 0 && index < current.length) {
      current[index] = { label: current[index].label, type: current[index].type, action: typeof value === 'string' ? value : '' };
      startingButtonsState.value = current;
      emitStartingButtons(current);
    }
  }

watch([showVectorDbTab, retrieverKValuePolicyMax, maxOutputTokensPolicyMax, () => props.retrieverKValue, () => props.maxOutputTokens, () => props.vectorDbQueriesLimit], () => {
  if (showVectorDbTab.value !== true && selectedTab.value === 'vectorDb') {
    selectedTab.value = 'extra';
  }
  if (retrieverKValuePolicyMax.value > 0) {
    const rawRetriever = Number(props.retrieverKValue);
    const nextRetriever = normalizeRetrieverKValue(props.retrieverKValue);
    if (Number.isFinite(rawRetriever) !== true || rawRetriever < 1 || rawRetriever !== nextRetriever) {
      emit('update:retrieverKValue', nextRetriever);
    }
  }
  if (maxOutputTokensPolicyMax.value > 0) {
    const rawMaxOutputTokens = Number(props.maxOutputTokens);
    const nextMaxOutputTokens = normalizeMaxOutputTokens(props.maxOutputTokens);
    if (Number.isFinite(rawMaxOutputTokens) !== true || rawMaxOutputTokens < 1 || rawMaxOutputTokens !== nextMaxOutputTokens) {
      emit('update:maxOutputTokens', nextMaxOutputTokens);
    }
  }
  const rawVectorDbQueriesLimit = Number(props.vectorDbQueriesLimit);
  const nextVectorDbQueriesLimit = normalizeVectorDbQueriesLimit(props.vectorDbQueriesLimit);
  if (Number.isFinite(rawVectorDbQueriesLimit) !== true || rawVectorDbQueriesLimit < 1 || rawVectorDbQueriesLimit !== nextVectorDbQueriesLimit) {
    emit('update:vectorDbQueriesLimit', nextVectorDbQueriesLimit);
  }
}, { immediate: true });
</script>